export default __webpack_public_path__ + "static/media/fr_light.32689ad5.png";